import { styled } from "@mui/system";
import { TextField } from "@mui/material";

const StyledTextField = styled(TextField)({
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#A1A5AC",
    },
    "&:hover fieldset": {
      borderColor: "#A1A5AC",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#A1A5AC",
    },
    borderRadius: "4px",
  },
  "& .MuiInputBase-input": {
    padding: "16px",
    color: "#ffffff",
    height: "20px",
    lineHeight: "20px",
    "&.Mui-disabled": {
      color: "#b9b9b9",
      "-webkit-text-fill-color": "#b9b9b9",
    },
  },
  "& .MuiInputLabel-root": {
    color: "#ffffff",
  },
  "& .MuiInputLabel-root.Mui-focused": {
    color: "#ffffff",
    fontWeight: "500",
  },
  "& .MuiOutlinedInput-input::placeholder": {
    fontStyle: "italic",
    color: "#F8F8F8",
    fontWeight: "500",
  },
  "& .MuiFormLabel-root": {
    color: "#F8F8F8",
    fontWeight: "500",
  },
  "& .MuiFormLabel-root .Mui-disabled .MuiInputBase-input": {
    color: "#b9b9b9",
    fontWeight: "500",
  },
});

export default StyledTextField;
